import React from "react";
import {
  FaInstagram,
  FaLinkedin,
  FaFacebook,
  FaTwitter,
} from "react-icons/fa6";

import { Link } from "react-scroll";
import styles from "./Home.module.css";

import AboutUs from "../About Us/AboutUs";
import Register from "../Register/Register";
import Prizes from "../Prizes/Prizes";
import Partner from "../Partners/Partners";
import Schedule from "../Schedule/Schedule";
import Flute from "../../assets/flute.svg";
import Drum from "../../assets/drum.svg";
import Dhapli from "../../assets/dhapli.svg";
import Keyboard from "../../assets/keyboard.svg";
import Organ from "../../assets/organ.svg";

const Home = () => {
  return (
    <div className={styles.main}>
      <img
        src={Flute}
        alt="flute"
        className={`${styles.commonClass} ${styles.flute}`}
      />
      <img
        src={Drum}
        alt="drum"
        className={`${styles.commonClass} ${styles.drum}`}
      />
      <img
        src={Dhapli}
        alt="dhapli"
        className={`${styles.commonClass} ${styles.dhapli}`}
      />
      <img
        src={Keyboard}
        alt="keyboard"
        className={`${styles.commonClass} ${styles.keyboard}`}
      />
      <img
        src={Organ}
        alt="organ"
        className={`${styles.commonClass} ${styles.organ}`}
      />
      <img
        src={Flute}
        alt="flute"
        className={`${styles.commonClass}  ${styles.flute_a}`}
      />
      <img
        src={Drum}
        alt="drum"
        className={`${styles.commonClass}  ${styles.drum_a}`}
      />
      <img
        src={Dhapli}
        alt="dhapli"
        className={`${styles.commonClass}  ${styles.dhapli_a}`}
      />
      <img
        src={Keyboard}
        alt="keyboard"
        className={`${styles.commonClass}  ${styles.keyboard_a}`}
      />
      <img
        src={Organ}
        alt="organ"
        className={`${styles.commonClass} ${styles.organ_a}`}
      />

      <div className={styles.home} id="page1">
        <div className={styles.content}>
          <p className={styles.heading}>Soulstrings</p>
          <p className={styles.details}>
            SoulStrings by Mood Indigo celebrates India's singer-songwriters,
            offering a vibrant platform to showcase, nurture, and inspire
            musical talent across the nation.
          </p>
          <div className={styles.homeButton}>
            <div id="register">
              <a
                href="https://docs.google.com/forms/d/e/1FAIpQLSfUIF8YYNhK6pFNCvpKxfEvjAH5mOC8vJ7e4HWUmVp_KggLzA/viewform"
                target="_blank"
                rel="noopener noreferrer"
              >
                <button className={`${styles.registerBtn} ${styles.redbtn}`}>REGISTER</button>
              </a>
            </div>
            <Link to="about" smooth={true} duration={500}>
              <button className={`${styles.registerBtn} ${styles.redbtn}`}>
                READ MORE
              </button>
            </Link>
          </div>
        </div>
      </div>
      <div id="about">
        <AboutUs />
      </div>

      <div id="page3">
        <Prizes />
      </div>
      <div id="page4">
        <Schedule />
      </div>

      <div id="register">
        <Register />
      </div>
      <div id="page5">
        <Partner />
      </div>

      <div className="foot">
        <div className="foot-comp" id="27">
          <h3 className="foot-head">ADDRESS</h3>
          <p className="foot-cont">
            Mood Indigo Office,
            <br />
            Student Activity Centre,
            <br />
            IIT Bombay.
          </p>
        </div>

        <div className="foot-comp contact" id="33">
          <p className="foot-head">CONTACT</p>
          <div className="foot-cont">
            <p>
              Yog Sonawane: <a href="tel:+917977058957">+91 79770 58957</a>
            </p>
            <p>
              Ranbir Sinha <a href="tel:+919137622913">+91 91376 22913</a>
            </p>
          </div>
        </div>

        <div className="foot-comp" id="34">
          <h3 className="foot-head">E-MAIL</h3>
          <p className="foot-cont">
            <a href="mailto:ranbir@moodi.org">
              ranbir@moodi.org
            </a>
            <br />
            <a href="mailto:yog@moodi.org">yog@moodi.org</a>
          </p>
        </div>

        <div className="foot-comp" id="35">
          <h3 className="foot-head">FOLLOW US</h3>
          <div className="foot-logos">
            <a
              href="https://www.facebook.com/iitbombay.moodi"
              className="foot-logo"
              aria-label="Facebook"
            >
              <FaFacebook
                size={window.innerWidth > 800 ? 40 : 50}
                color="#077167"
                className="foot_logo"
              />
            </a>
            <a
              href="https://www.instagram.com/iitbombay.moodi/"
              className="foot-logo"
              aria-label="Instagram"
            >
              <FaInstagram
                size={window.innerWidth > 800 ? 40 : 50}
                color="#077167"
                className="foot_logo"
              />
            </a>
            <a
              href="https://twitter.com/iitb_moodi?ref_src=twsrc%5Egoogle%7Ctwcamp%5Eserp%7Ctwgr%5Eauthor"
              className="foot-logo"
              aria-label="Twitter"
            >
              <FaTwitter
                size={window.innerWidth > 800 ? 40 : 50}
                color="#077167"
                className="foot_logo"
              />
            </a>
            <a
              href="https://www.linkedin.com/company/mood-indigo/mycompany/"
              className="foot-logo"
              aria-label="LinkedIn"
            >
              <FaLinkedin
                size={window.innerWidth > 800 ? 40 : 50}
                color="#077167"
                className="foot_logo"
              />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
